import { CustomFieldViewSection } from "@/components/custom-field/custom-field-view-sections.ts";
import useCustomFieldsHook from "@/hooks/use-custom-fields.hook.tsx";
import { Skeleton, Stack, Title } from "@skailer-com/uikit";
import { Fragment } from "react";

interface CustomFieldViewSectionsProps {
  sections: CustomFieldViewSection[];
  isPending: boolean;
  paddingTop?: boolean;
}

export const CustomFieldViewSections = ({
  sections,
  isPending,
  paddingTop = false,
}: CustomFieldViewSectionsProps) => {
  const { getSectionTitle } = useCustomFieldsHook();

  return (
    <>
      {isPending && (
        <Stack className={"py-2"} gap={"md"}>
          <Skeleton className={"h-5 w-full"} />
          <Skeleton className={"h-5 w-full"} />
        </Stack>
      )}
      {sections.map(({ section, items }, index) => (
        <Stack key={section.id}>
          <Title
            header={getSectionTitle(section)}
            paddingTop={paddingTop || index !== 0}
            size={"xs"}
            variant={"secondary"}
          />
          {items.map(({ field, node }) => (
            <Fragment key={field.id}>{node}</Fragment>
          ))}
        </Stack>
      ))}
    </>
  );
};
